import { Heading, HeadingLevel } from "@ariakit/react";
import {
  ListItemContainer,
  ListItemContent,
  ListItemHeading,
  ListItemSummary,
  ListView,
  MinWidth,
  useCurrentUser,
  useMediaQuery,
} from "@indietabletop/appkit";
import { Link } from "wouter";
import { href } from "../App/href";
import { brookshire, button, center, withScrollbars } from "../common.css";
import { GravehelmBanner } from "../Gravehelm/GravehelmBanner";
import {
  PageContainer,
  PageContent,
  PageHeader,
  PageHeaderTitle,
  SplitView,
  ViewContent,
} from "../oss/Layout/Layout";
import { navLinks } from "../oss/Layout/navLinks";
import { BookCover } from "../RedeemPage/RedeemPage";
import { vars } from "../vars.css";
import armorSrc from "./armor.png";
import { Footer } from "./Footer";
import { auth, item, list } from "./style.css";

function AppHeader() {
  return (
    <div style={{ textAlign: "center", paddingBlock: "2rem 3rem" }}>
      <Heading>
        <div
          className={brookshire}
          style={{ fontSize: "2.5rem", lineHeight: 1 }}
        >
          Greathelm
        </div>
        <div
          style={{
            fontSize: "1rem",
            fontStyle: "italic",
            fontWeight: 400,
          }}
        >
          Companion App
        </div>
      </Heading>
    </div>
  );
}

function DashboardListItem(props: {
  heading: string;
  summary: string;
  href: string;
}) {
  const { heading, summary, href } = props;
  return (
    <ListItemContainer>
      <ListItemContent render={<Link href={href} />} className={item.container}>
        <ListItemHeading className={item.heading}>{heading}</ListItemHeading>
        <ListItemSummary className={item.summary}>{summary}</ListItemSummary>
      </ListItemContent>
    </ListItemContainer>
  );
}

function DashboardLinks() {
  return (
    <ListView className={list.container}>
      <ListItemContainer>
        <GravehelmBanner />
      </ListItemContainer>

      {navLinks.map((link) => {
        return <DashboardListItem key={link.href} {...link} />;
      })}
    </ListView>
  );
}

function AuthSection() {
  const currentUser = useCurrentUser();

  const info = currentUser ? (
    <p className={auth.info}>Logged in as {currentUser.email}.</p>
  ) : (
    <p className={auth.info}>
      Enable backup & sync, unlock owned content, and more, with an{" "}
      <em>Indie Tabletop Club</em> account.
    </p>
  );

  const actions = currentUser ? (
    <div className={auth.actions}>
      <Link
        href={href("~/settings")}
        className={button({ size: "small", theme: "white" })}
      >
        Account Settings
      </Link>
    </div>
  ) : (
    <div className={auth.actions}>
      <Link href={href("~/join")} className={button({ size: "small" })}>
        Join
      </Link>

      <Link href={href("~/login")} className={button({ size: "small" })}>
        Log in
      </Link>
    </div>
  );

  return (
    <div className={auth.container}>
      <img src={armorSrc} alt="" className={auth.image} />

      {info}

      {actions}
    </div>
  );
}

export function DashboardPage() {
  const isMediumOrWider = useMediaQuery(MinWidth.MEDIUM);

  if (isMediumOrWider) {
    return (
      <HeadingLevel>
        <SplitView>
          <PageContainer>
            <PageContent>
              <div
                style={{
                  paddingInline: vars.view.paddingInline,
                  paddingBlock: vars.view.paddingInline,
                  maxInlineSize: "28rem",
                  marginInline: "auto",
                }}
              >
                <AppHeader />
                <DashboardLinks />

                <AuthSection />
              </div>

              <Footer />
            </PageContent>
          </PageContainer>

          <div
            className={withScrollbars}
            style={{
              overflowY: "auto",
              blockSize: "100dvh",
            }}
          >
            <div
              style={{
                minBlockSize: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                paddingInline: vars.view.paddingInline,
                paddingBlock: "2rem",
              }}
            >
              <div
                className={center}
                style={{
                  position: "relative",
                  rotate: "3deg",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    inset: "0",
                    backgroundColor: "hsl(0 0% 0% / 0.05)",
                    borderRadius: "50%",
                    aspectRatio: 1,
                    maxInlineSize: "22rem",
                    margin: "auto",
                  }}
                />

                <BookCover />
              </div>

              <Link
                href={href("~/shop")}
                className={button()}
                style={{ marginBlockStart: "2rem" }}
              >
                Get the rules!
              </Link>
            </div>
          </div>
        </SplitView>
      </HeadingLevel>
    );
  }

  return (
    <HeadingLevel>
      <PageContainer>
        <PageHeader>
          <div />
          <PageHeaderTitle>Greathelm</PageHeaderTitle>
          <div />
        </PageHeader>

        <PageContent>
          <ViewContent blockVariant="shrink">
            <DashboardLinks />
            <AuthSection />
          </ViewContent>

          <Footer />
        </PageContent>
      </PageContainer>
    </HeadingLevel>
  );
}
